'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const EmailIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="EmailIcon">
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M23.75 17.5486C23.75 17.9464 23.592 18.3279 23.3107 18.6092C23.0294 18.8905 22.6478 19.0486 22.25 19.0486H5.25C4.85218 19.0486 4.47064 18.8905 4.18934 18.6092C3.90804 18.3279 3.75 17.9464 3.75 17.5486V3.54858C3.75 3.3516 3.7888 3.15655 3.86418 2.97456C3.93956 2.79257 4.05005 2.62721 4.18934 2.48792C4.47064 2.20662 4.85218 2.04858 5.25 2.04858H22.25C22.6478 2.04858 23.0294 2.20662 23.3107 2.48792C23.592 2.76923 23.75 3.15076 23.75 3.54858V17.5486Z"
          stroke={sx?.color || '#3D517B8F'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.25 2.54858L13.75 11.5486L4.25 2.54858"
          stroke={sx?.color || '#3D517B8F'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 6.07059H1.75C1.48478 6.07059 1.23043 6.17594 1.04289 6.36348C0.855357 6.55102 0.75 6.80537 0.75 7.07059V21.0706C0.75 21.3358 0.855357 21.5902 1.04289 21.7777C1.23043 21.9652 1.48478 22.0706 1.75 22.0706H18.75C19.0152 22.0706 19.2696 21.9652 19.4571 21.7777C19.6446 21.5902 19.75 21.3358 19.75 21.0706V19.0706"
          stroke={sx?.color || '#3D517B8F'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

EmailIcon.propTypes = {
  sx: PropTypes.object
}
